import { FileOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import React from 'react';
import css from './ContactSuppression.module.css';

export const ContactSuppressionHeader = ({
  isSuppression,
  onClick,
  count = 0,
  withNote = false,
}: {
  isSuppression: boolean;
  onClick?: () => void;
  count?: number;
  withNote?: boolean;
}) => {
  const title = isSuppression
    ? 'Existing Contact Suppression'
    : 'Unsubscribe List';
  const subtitle = isSuppression
    ? 'Upload your existing contacts to suppress contact creation'
    : '  Upload lists of contacts that you do not want to track any data or engagement on';
  return (
    <div className={css.headerContainer}>
      <div className={css.headerTitle}>
        <div className={css.title}>{title}</div>
        <div className={css.subheading}>{subtitle}</div>
      </div>
      <div className={css.header}>
        {withNote && (
          <div className={css.info}>
            <InfoCircleOutlined className={css.infoIcon} /> Updated every hour{' '}
          </div>
        )}
        {!!count && (
          <div className={css.listStat}>
            <FileOutlined className={css.fileIcon} />
            <div className={css.column}>
              <span className={css.count}>{count}</span>
              Lists
            </div>
          </div>
        )}
        {onClick && (
          <Button
            color="transparent-no-shadow"
            css={{ container: css.transparentButton }}
            onClick={e => {
              e?.stopPropagation();
              onClick();
            }}
          >
            Add a List
          </Button>
        )}
      </div>
    </div>
  );
};
